import React from "react";
import { SocialBar, Text } from "@jobmatchme/ui";
import styles from "./style.module.scss";

const SocialButtons = () => (
  <div className={styles.socialButtons}>
    <Text align="center">Folgen Sie uns</Text>
    <SocialBar color="#fff" originalColorOnHover />
  </div>
);

export default SocialButtons;
